import { ForWhomEnum, UserRoleEnum } from '@/modules/core/models/enums'
import DentalHiringInsured from '@/modules/dental/hiring/models/APP/DentalHiringInsured'
import HiringAnswers from '@/modules/common/hiring/models/APP/HiringAnswers'

export default class DentalHiringAnswers extends HiringAnswers<DentalHiringInsured> {
  protected _holder = new DentalHiringInsured()

  // ? forWhom: string
  // ? forWhomPeople: number
  hasRelationship: string
  hasHealthInsurance: string | null

  constructor(data: Partial<DentalHiringAnswers> = {}) {
    super(data)

    this.insureds = data.insureds
    this.holder = data.holder
    this.hasHealthInsurance = data.hasHealthInsurance ?? null
    this.hasRelationship = data.hasRelationship ?? 'yes'
  }

  get forWhomPeople() {
    return this.insureds.length
  }
  get forWhom() {
    const holderRole = this.holder.role
    if (holderRole === UserRoleEnum.HOLDER_NOT_INSURED) {
      return ForWhomEnum.NOT_ME
    }

    if (this.forWhomPeople === 1) {
      return ForWhomEnum.ME
    }

    return ForWhomEnum.ME_MORE
  }

  get insureds(): DentalHiringInsured[] {
    return this._insureds
  }

  set insureds(value: DentalHiringInsured[] | undefined) {
    this._insureds = value?.map((i) => new DentalHiringInsured(i)) ?? []
  }

  get holder(): DentalHiringInsured {
    return this._holder
  }

  set holder(value: DentalHiringInsured | undefined) {
    this._holder.updateAttributes(value ?? {})
  }

  get currentInsured(): DentalHiringInsured | null {
    return this._currentInsured ?? null
  }

  set currentInsured(value: DentalHiringInsured | null | undefined) {
    this._currentInsured = value ? new DentalHiringInsured(value) : null
  }

  updateAttributes(newAttributes: Partial<DentalHiringAnswers>) {
    Object.assign(this, newAttributes)
  }

  hasBetterAssurance(): boolean {
    return !!this.insureds.find((insured) => insured.additionalCoverages?.length)
  }
}
